// extracted by mini-css-extract-plugin
export var banner = "personal-training-page-module--banner--7d3d3";
export var content = "personal-training-page-module--content--e993f";
export var trainingSwitcher = "personal-training-page-module--training-switcher--04366";
export var wrapper = "personal-training-page-module--wrapper--bc2d3";